import React from "react";
import ActionDropdown from "./ActionDropdown";

const TableRow = ({
  row,
  headers,
  rowKey,
  isDropdownOpen,
  toggleDropdown,
  onActionClick,
  rowIndex,
  rowClassName,
  tableStyle, // Add prop
}) => {
  const renderCellContent = (key, value) => {
    // Special rendering for status column
    if (key === "status") {
      return (
        <span
          className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
            value === "Paid"
              ? "bg-green-100 text-green-800"
              : value === "Unpaid"
              ? "bg-red-100 text-red-800"
              : "bg-gray-100 text-gray-800"
          }`}
        >
          <span
            className={`w-1.5 h-1.5 mr-1.5 rounded-full ${
              value === "Paid"
                ? "bg-green-400"
                : value === "Unpaid"
                ? "bg-red-400"
                : "bg-gray-400"
            }`}
          ></span>
          {value}
        </span>
      );
    }

    // Special rendering for amount summary column
    if (key === "amount_summary" && value && typeof value === "object") {
      return (
        <div className="text-sm">
          <div className="font-medium">Total: Rs. {value.total || 0}</div>
          <div className="text-green-600">Paid: Rs. {value.paid || 0}</div>
          <div className="text-red-600">Unpaid: Rs. {value.unpaid || 0}</div>
        </div>
      );
    }

    // Special rendering for amounts
    if (key.includes("amount")) {
      return value ? `Rs. ${value}` : "Rs. 0";
    }

    // Default rendering
    return value || "";
  };

  return (
    <tr
      className={`${
        rowIndex % 2 === 0 ? "bg-white" : "bg-white"
      } border-b border-gray-200 ${rowClassName}`}
    >
      {headers.map(({ key }, headerIdx) => (
        <td
          key={key}
          className={`py-2 px-4 ${
            headerIdx === 0 || headerIdx === 1
              ? "cursor-pointer hover:underline"
              : ""
          }`}
          onClick={
            headerIdx === 0
              ? () => onActionClick("View", row)
              : headerIdx === 1
              ? () => onActionClick("Employee", row)
              : undefined
          }
          style={tableStyle} // Apply tableStyle to td
        >
          {renderCellContent(key, row[key])}
        </td>
      ))}
      <td className="py-2 px-4 text-start relative" style={tableStyle}>
        <button
          className="text-gray-500 hover:text-gray-700"
          onClick={(e) => {
            e.stopPropagation();
            toggleDropdown(rowIndex);
          }}
          aria-label="Open actions menu"
        >
          <i className="fas fa-ellipsis-h"></i>
        </button>
        <ActionDropdown
          isOpen={isDropdownOpen}
          row={row}
          headers={headers}
          onActionClick={onActionClick}
          onClose={() => toggleDropdown(null)}
        />
      </td>
    </tr>
  );
};

export default TableRow;
